import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../components-v2/Theme/theme';

const { colors, spacing } = THEME;

export const styleSheet = StyleSheet.create({
	databoard: {
		flex: 1,
		minHeight: 0,
		background: 'transparent',
		gap: spacing.md,
		marginBottom: spacing.md,
	},
	databoardBody: {
		background: colors.background.light,
		height: '100%',
		overflow: 'auto',
	},
	sortIcon: {
		marginLeft: spacing.sm,
	},
	sortIconFlipped: {
		transform: 'rotate3d(0,0,1, 180deg)',
	},
	sortMenu: {
		gap: spacing.sm,
	},
	sortMenuItem: {
		padding: `${spacing.sm}px ${spacing.md}px`,
		width: '100%',
		display: 'flex',
		':hover': {
			backgroundColor: colors.hover.light,
		},
	},
	sortTrigger: {
		alignItems: 'center',
		cursor: 'pointer',
		display: 'flex',
		fontSize: 12,
		gap: spacing.sm,
		textTransform: 'uppercase',
		fontWeight: 600,
	},
	nameColumn: {
		width: '35%',
	},
	contactsColumn: {
		width: '15%',
	},
	companiesColumn: {
		width: '15%',
	},
	tagAlertColumn: {
		width: '35%',
	},
	cell: {
		padding: spacing.sm,
	},
	addTagButton: {
		display: 'flex',
		gap: spacing.sm,
		alignItems: 'center',
	},
	link: {
		color: colors.primary.main,
		textDecoration: 'none',
		fontWeight: 600,
		cursor: 'pointer',
	},
	noWrap: {
		whiteSpace: 'nowrap',
	},
	placeholder: {
		marginTop: 60,
	},
	menuColumn: {
		gap: spacing.md,
	},
	menuContent: {
		padding: `${spacing.sm}px 0`,
	},
	menuItem: {
		padding: `${spacing.sm}px ${spacing.md}px`,
		transition: 'color .5s, background-color .5s',
		':hover': {
			backgroundColor: colors.hover.light,
		},
	},
	menuTrigger: {
		color: colors.icon.gray,
	},
});
